import {Injectable} from '@angular/core';
import {NgModule} from '@angular/core';

import {Type} from '@angular/core';

import {DesktopStat} from "../../framework/model/general/desktopStats/desktopStat";
import {ContentType} from "../../framework/model/general/contentType";
import {Puser} from "../../framework/model/puser/puser";
import {PuserType} from "../../framework/model/general/puser/puserType";
import {DesktopLink} from "../../framework/model/general/desktopLink/desktopLink";
import {ColumnModel} from "../../framework/model/columnModel";
import {DesktopStatFilter} from "../../framework/model/general/desktopStats/desktopStatFilter";
import {Signature} from "../../framework/model/general/signature";
import {ModelStatus} from "../../framework/model/modelStatus";
import {GlobalSettings} from "../../framework/model/core/business/globalSettings";
import {AppUser} from "../../framework/model/core/appuser/appuser";
import {Address} from "../../framework/model/core/address/address";
import {BusinessImages} from "../../framework/model/core/business/businessImages";
import {Section} from "../../framework/model/core/sections/section";
import {Item} from "../../framework/model/core/items/item";
import {ItemMaker} from "../../framework/model/core/items/itemMaker";
import {OrderItem} from "../../framework/model/core/order/orderItem";
import {MainAdvertise} from "../../framework/model/core/advertise/advertise";
import {Deal} from "../../framework/model/core/deal/deal";
import {ItemToDeal} from "../../framework/model/core/deal/itemToDeal";
import {DealProperty} from "../../framework/model/core/deal/dealProperty";
import {DealPropertyType} from "../../framework/model/core/deal/dealPropertyType";
import {DealTypeByProperty} from "../../framework/model/core/deal/dealTypeByProperty";
import {DealGeneralPropertyType} from "../../framework/model/core/deal/dealGeneralPropertyType";
import {DealGeneralProperty} from "../../framework/model/core/deal/dealGeneralProperty";
import {DealGroup} from "../../framework/model/core/deal/dealGroup";
import {ItemToDealGroup} from "../../framework/model/core/deal/itemToDealGroup";
import {Area} from "../../framework/model/core/area/area";
import {Note} from "../../framework/model/general/note/note";
import {Business} from "../../framework/model/core/business/business";
import {Order} from "../../framework/model/core/order/order";
import {ModelToImage} from "../../framework/model/core/general/modelToImage";
import {CartItem} from "../../framework/model/core/cart/cartItem";
import {Coupon} from "../../framework/model/core/coupon/coupon";
import {MiniItem} from "../../framework/model/core/items/miniitem";
import {Template} from "../../framework/model/core/template/template";
import {Branch} from "../../framework/model/core/branch/branch";
import {SaleBonus} from "../../framework/model/core/sales/saleBonus";
import {Company} from "../../framework/model/core/company/company";
import {Ticket} from "../../framework/model/core/ticket/ticket";
import {TicketMessage} from "../../framework/model/core/ticketMessage/ticketMessage";
import {Image} from "../../framework/model/general/image";
import {Book} from "../../framework/model/core/book/book";

import {ItemToUser} from "../../framework/model/core/items/itemToUser";
import {StockReport} from "../../framework/model/core/stock/stockReport";
import {WeeklyReport} from "../../framework/model/core/stock/weeklyReport";
import {BandObligoChecks} from "../../framework/model/core/bandObligoChecks/bandObligoChecks";
import {BandObligoFncitems} from "../../framework/model/core/bandObligoFncitems/bandObligoFncitems";
import {BandObligoTrans} from "../../framework/model/core/bandObligoTrans/bandObligoTrans";
import {Panel} from "../../framework/model/core/panel/panel";
import {City} from "../../framework/model/core/city/city";
import {Neighborhood} from "../../framework/model/core/city/neighborhood";
import {AddressDetails} from "../../framework/model/core/address/addressDetails";
import {State} from "../../framework/model/core/city/state";
import {SubType} from "../../framework/model/core/type/subType";
import {Type as AppType} from "../../framework/model/core/type/type";
import {Stock} from "../../framework/model/core/stock/stock";
import {AppComment} from "../../framework/model/general/comment";
import {Report} from "../../framework/model/general/reprot/report";
import {Post} from "../../framework/model/core/post/post";
import {PostComment} from "../../framework/model/core/post/postComment";
import {OpenInvoice} from "../../framework/model/core/invoice/openInvoice";
import {DelayedRelay} from "../../framework/model/core/invoice/delayedRelay";
import {CompanyCoupon} from "../../framework/model/core/coupon/companyCoupon";
import {ApiInvoice} from "../../framework/model/core/invoice/apiInvoice";

export class AdItem {
    constructor(public component: Type<any>){
    }
}

@NgModule({})
@Injectable()
export class ModelClasses {

    classes = {
        'business': new AdItem(Business),
        'globalsettings': new AdItem(GlobalSettings),
        'appuser': new AdItem(AppUser),
        'company': new AdItem(Company),
        'address': new AdItem(Address),
        'shipmentadress': new AdItem(Address),
        'addressdetails': new AdItem(AddressDetails),
        'order': new AdItem(Order),
        'image': new AdItem(Image),
        'modeltoimage': new AdItem(ModelToImage),
        'template': new AdItem(Template),

        'businessimages': new AdItem(BusinessImages),
        'section': new AdItem(Section),
        'miniitem': new AdItem(Item),
        'item': new AdItem(Item),
        'itemmaker': new AdItem(ItemMaker),
        'book': new AdItem(Book),

        'post': new AdItem(Post),
        'postComment': new AdItem(PostComment),
        'postcomment': new AdItem(PostComment),

        'salebonus': new AdItem(SaleBonus),

        'orderitem': new AdItem(OrderItem),
        'mainadvertise': new AdItem(MainAdvertise),
        'branch': new AdItem(Branch),
        'ticket': new AdItem(Ticket),
        'ticketmessage': new AdItem(TicketMessage),

        'panel': new AdItem(Panel),

        //
        'deal': new AdItem(Deal),
        'itemtodeal': new AdItem(ItemToDeal),
        'dealproperty': new AdItem(DealProperty),
        'dealpropertytype': new AdItem(DealPropertyType),
        'dealtypebyproperty': new AdItem(DealTypeByProperty),
        'dealgeneralpropertytype': new AdItem(DealGeneralPropertyType),
        'dealgeneralproperty': new AdItem(DealGeneralProperty),
        'dealgroup': new AdItem(DealGroup),
        'itemtodealgroup': new AdItem(ItemToDealGroup),

        'itemtouser': new AdItem(ItemToUser),
        'stockreport': new AdItem(StockReport),
        'stock': new AdItem(Stock),
        'weeklyreport': new AdItem(WeeklyReport),

        'area': new AdItem(Area),

        'cartitem': new AdItem(CartItem),
        'coupon': new AdItem(Coupon),
        'companycoupon': new AdItem(CompanyCoupon),

        'modelstatus': new AdItem(ModelStatus),
        'contenttype': new AdItem(ContentType),
        'signature': new AdItem(Signature),
        'puser': new AdItem(Puser),
        // 'genericmodel': new AdItem(GenericModel),
        'desktopstat': new AdItem(DesktopStat),
        'desktopstatfilter': new AdItem(DesktopStatFilter),
        'desktoplink': new AdItem(DesktopLink),
        'columnmodel': new AdItem(ColumnModel),
        // 'info': new AdItem(Info),
        'pusertype': new AdItem(PuserType),
        'note': new AdItem(Note),
        
        'state': new AdItem(State),
        'city': new AdItem(City),
        'neighborhood': new AdItem(Neighborhood),

        'type': new AdItem(AppType),
        'subtype': new AdItem(SubType),

        'openinvoice': new AdItem(OpenInvoice),
        'delayedrelay': new AdItem(DelayedRelay),

        'bandobligochecks': new AdItem(BandObligoChecks),
        'bandobligofncitems': new AdItem(BandObligoFncitems),
        'bandobligotrans': new AdItem(BandObligoTrans),
        'comment': new AdItem(AppComment),
        'report': new AdItem(Report),
        'apiinvoice': new AdItem(ApiInvoice),
    }

    constructor() {
    }

    //depricated!
    public getClass(modelPrefix) {

        // //console.log"load class: ");
        // //console.logmodelPrefix);
        let pref = modelPrefix.toLowerCase();
        // //console.logpref);
        // //console.logthis.classes[pref]);

        return this.classes[pref] ? this.classes[pref].component : null;
    }

    public getModelClass(modelPrefix) {
        // //console.logmodelPrefix);
        let pref = modelPrefix.toLowerCase();
        ////console.logpref);
        // //console.logthis.classes[pref]);
        return this.classes[pref] ? this.classes[pref].component : null;
    }
}
